<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div class="table-responsive">
                            <table id="table" class="table table-striped " cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th *ngFor="let title of titles">{{title}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--*ngFor="let row of data; let i = index"-->
                                    <tr>
                                        <td>Invitation email</td>
                                        <td>Invitation</td>
                                        <td>Regular</td>
                                        <td>General</td>
                                        <td>
                                            <i [routerLink]="['/app/emailtemplate']" class="material-icons">remove_red_eye</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Reminder email v1.0</td>
                                        <td>Reminder</td>
                                        <td>Regular</td>
                                        <td>General</td>
                                        <td>
                                            <i [routerLink]="['/app/emailtemplate']" class="material-icons">remove_red_eye</i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>360 result email v1.0</td>
                                        <td>Result</td>
                                        <td>360</td>
                                        <td>Sports</td>
                                        <td>
                                            <i [routerLink]="['/app/emailtemplate']" class="material-icons">remove_red_eye</i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
